import { render, staticRenderFns } from "./IntelytCard.vue?vue&type=template&id=3145281e&scoped=true&"
import script from "./IntelytCard.vue?vue&type=script&lang=js&"
export * from "./IntelytCard.vue?vue&type=script&lang=js&"
import style0 from "./IntelytCard.vue?vue&type=style&index=0&id=3145281e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3145281e",
  null
  
)

export default component.exports